import React from 'react';

export default {
  companionDirect: {
    confetti: {
      heading: "You've also been pre-approved for FlexiPay",
      subheadings: () => [
        'FlexiPay is a revolving line or credit to spread business costs',
        'Repay over 1, 3, 6, 9 or 12 monthly instalments.'
      ]
    },
    amountApprovedCard: {
      amountApprovedTitle: 'Your pre-approved credit limit',
      details: () => [
        ['Interest', '0%'],
        ['Set up and annual fee', '£0'],
        ['Fees', 'from 5.49% (based on a 3 month repayment term)']
      ]
    },
    featuresList: {
      featuresListHeading: 'Thousands of businesses are using FlexiPay to',
      featuresListLabels: () => [
        'Use for any business purpose',
        'Cover everyday expenses on the go',
        'Bulk buy to negotiate a better deal',
        'Pay suppliers, payroll or unexpected invoices',
        'Purchase stock or equipment',
        'Pay VAT, energy or other business bills'
      ]
    },
    steps: () => [
      {
        step: '1',
        heading: 'Set up FlexiPay',
        paragraph:
          'Your line of credit will be ready to use for making payments straightaway, and your card will arrive within 10 working days.'
      },
      {
        step: '2',
        heading: 'Pay for business costs',
        paragraph:
          'Either make payments with your card, or sign in and enter the details of the bill, invoice or other business costs and we’ll make a secure payment in your name.'
      },
      {
        step: '3',
        heading: 'Repay in monthly instalments',
        paragraph:
          'You won’t be charged any interest, just a flat fee and the credit available for you to use again'
      }
    ],
    disclaimer: ({ creditAgreementUrl, styles }) => (
      <>
        By keeping ‘yes’ selected, you confirm that you have read and accept
        your{' '}
        <a
          href={creditAgreementUrl}
          data-testid='flexipay-credit-agreement'
          className={styles}
          download>
          FlexiPay credit agreement
        </a>
      </>
    ),
    setupFlexipayRadioGroupHeading:
      'Set up FlexiPay alongside your loan for free?',
    acceptOfferButton: 'Review your loan contract'
  }
};
